module.exports = __webpack_public_path__ + "static/img/GettyImages-692753467.f1cdb63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/GettyImages-692753467.jpg
// module id = ujoZ
// module chunks = 0